





























































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import Questions from "../components/Questions.vue";
import * as franc from "franc";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
Vue.use(VueApexCharts);

@Component({
  props: ["topicId"],
  components: {
    question: Questions,
    apexchart: VueApexCharts,
  },
})
export default class VideoQuiz extends Vue {
  private service = new GeneralService();
  private items: GActivity[] = [];
  private questions: QuestionE[] = [];
  private questionComponentKey = 0;
  private answers: any = [];
  private apiLoaded = false;
  private sheetAnswerData: any = [];
  private checkAnswers = false;
  private isQuestion = false;
  private attempted: number = 0;
  private topicId: string;
  private level_id;
  private isResult = false;
  private totalSeries = 0;
  private checkTopic = false;
  private startTime = moment();
  private endTime = moment();
  private timeElapsed = "";
  private auth = new AuthService();
  private mcqlimit = 10000;
  private correct = 0;
  private incorrect = 0;
  private chapterlimit = 10000;
  private topiclimit = 10000;
  private modalShow = false;
  private emptyAnswers: any = [];
  private isPastPaper = false;
  private isShortQuestions = false;
  private totalSeriesData;
  private isLongQuestions = false;
  private savedOperations: any = [];
  private lastSaved: null | string = null;

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  answerAttempt(response) {
    if (this.answers !== undefined && response !== undefined) {
      let trueAns = this.answers.find(
        (e) => e.questionId === response.questionId
      );

      if (trueAns !== undefined) {
        trueAns.answer = true;
        trueAns.answerId = response.answerId;
      }

      let questionType = this.questions.find(
        (e) => e.qid === response.questionId
      );

      if (questionType !== undefined) {
        questionType.questiontype =
          response.styles == undefined ? 1 : response.styles == "red" ? 3 : 2;
      }

      if (response.styles == "alert-success") {
        this.correct++;
      } else {
        this.incorrect++;
      }

      this.attempted = this.answers.filter((e) => e.answer === true).length;
    }
  }

  private finishQuiz() {
    this.checkAnswers = !this.checkAnswers;
    this.isResult = true;

    let series: any = [];
    series.push(this.correct);
    series.push(this.incorrect);
    series.push(this.questions.length - this.correct - this.incorrect);

    this.service
      .updateTopicMarks(this.topicId, this.correct + '/' + this.questions.length).then((response) => {
        if (response) {
          this.lastSaved = response[0].result;
        }
      });

    this.totalSeriesData = series;
    this.totalSeries++;
    this.endTime = moment();

    if (this.endTime.diff(this.startTime, "hours") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "hours", true).toFixed(2) + " Hours";
    } else if (this.endTime.diff(this.startTime, "minutes") !== 0) {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "minutes", true).toFixed(2) +
        " Minutes";
    } else {
      this.timeElapsed =
        this.endTime.diff(this.startTime, "seconds") + " Seconds";
    }
  }

  private reviewQuiz() {
    this.isResult = false;
    this.checkAnswers = true;
  }

  get chartTotalOptions() {
    let series: any = [];
    series.push("Correct");
    series.push("Incorrect");
    series.push("Not Attempted");

    let options = {
      labels: series,
      colors: ["#218F2C", "#B82121", "#979797"],
      legend: {
        show: false,
      },
    };
    return options;
  }

  private saveMCQ() {
    this.saveWatched();
    if (this.savedOperations.length < 1) {
      for (let i = 0; i < this.answers.length; i++) {
        let isExists = false;
        for (let j = 0; j < this.savedOperations.length; j++) {
          if (
            this.answers[i].questionId == this.savedOperations[j].questionId &&
            this.answers[i].isPastPaper == this.savedOperations[j].isPastPaper
          ) {
            this.savedOperations[j] = this.answers[i];
            isExists = true;
          }
        }
        if (!isExists) {
          this.savedOperations.push(this.answers[i]);
        }
      }
      this.service
        .insertSheetAnswers(
          config.createGuid(),
          this.topicId,
          this.savedOperations
        )
        .then((response) => {
          this.$router.push("mcqsubject?type=pastpaper");
        })
        .catch((err) => {
          if (this.isPastPaper) {
            this.$router.push("mcqsubject?type=pastpaper");
          } else {
            this.$router.push("mcqsubject");
          }
        });
    } else {
      for (let i = 0; i < this.answers.length; i++) {
        let isExists = false;
        for (let j = 0; j < this.savedOperations.length; j++) {
          if (
            this.answers[i].questionId == this.savedOperations[j].questionId &&
            this.answers[i].isPastPaper == this.savedOperations[j].isPastPaper
          ) {
            this.savedOperations[j] = this.answers[i];
            isExists = true;
          }
        }
        if (!isExists) {
          this.savedOperations.push(this.answers[i]);
        }
      }
      this.service
        .updateSheetAnswers(
          this.sheetAnswerData.userMcqResponseId,
          this.topicId,
          this.savedOperations
        )
        .then((response) => {
          this.$router.push("mcqsubject?type=pastpaper");
        })
        .catch((err) => {
          if (this.isPastPaper) {
            this.$router.push("mcqsubject?type=pastpaper");
          } else {
            this.$router.push("mcqsubject");
          }
        });
    }
  }

  private getNumber() {
    if (this.isShortQuestions) {
      return 2;
    } else if (this.isLongQuestions) {
      return 3;
    } else {
      return 1;
    }
  }

  goBack() {
    if (this.isPastPaper) this.$router.push("mcqsubject?type=pastpaper");
    else if (this.isShortQuestions)
      this.$router.push("mcqsubject?type=shortquestions");
    else if (this.isLongQuestions)
      this.$router.push("mcqsubject?type=longquestions");
    else this.$router.push("mcqsubject");
  }

  private async getQuestions() {
    this.questions = [];

    await this.service
      .getVideoQuestions(this.topicId)
      .then((result) => {
        this.answers = [];
        this.emptyAnswers = [];
        this.apiLoaded = true;
        for (let quest of result) {
          this.answers.push({
            questionId: quest.qid,
            answer: false,
            answerId: "",
            isPastPaper: false,
          });
          try {
            quest.fullquestion = config.renderHTML(quest.fullquestion);
          } catch {
            result.splice(
              result.findIndex((e) => e.fullquestion == quest.fullquestion),
              1
            );
          }
        }

        this.questions = result.splice(
          0,
          Math.min(result.length, this.mcqlimit)
        );
        this.emptyAnswers = this.answers;
        this.getSavedData(this.topicId);
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private getSavedData(id) {
    this.service.getSheetAnswers(id).then((data) => {
      if (data.length > 0)
        this.savedOperations = JSON.parse(data[0].operations);
      if (data.length > 0 && !this.isPastPaper) {
        this.sheetAnswerData = data[0];
        let answersTemp = JSON.parse(data[0].operations);
        for (let j = 0; j < this.answers.length; j++) {
          for (let i = 0; i < answersTemp.length; i++) {
            if (
              this.answers[j].questionId == answersTemp[i].questionId &&
              answersTemp[i].isPastPaper == false
            ) {
              this.answers[j] = answersTemp[i];
            }
          }
        }
        this.attempted = this.answers.filter((e) => e.answer === true).length;
        this.questionComponentKey++;
      } else if (data.length > 0 && this.isPastPaper) {
        this.sheetAnswerData = data[0];
        let questionsData = JSON.parse(data[0].operations);
        for (let i = 0; i < questionsData.length; i++) {
          for (let j = 0; j < this.answers.length; j++) {
            if (
              this.answers[j].questionId == questionsData[i].questionId &&
              questionsData[i].isPastPaper == true
            )
              this.answers[j] = questionsData[i];
          }
        }
        this.attempted = this.answers.filter((e) => e.answer === true).length;
        this.questionComponentKey++;
      } else {
        this.sheetAnswerData = [];
      }
    });
  }

  private saveWatched() {
    // this.saveElastic();

    var topicsWatched: McqAttempted = {
      mcqAttemptId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.topicId,
      operationOn: new Date(Date.now()),
      duration: this.attempted,
      percentage: this.isPastPaper ? -1 : -2,
    };

    this.service.insertMcq(topicsWatched).catch((err) => {
      console.error(`Error: ${err.message}`);
    });
  }

  saveElastic() {
    var msc = "";
    for (var que of this.answers) {
      if (que.answer == true) {
        msc = que.questionId + "=" + que.answer + ":";
        this.elasticSearchMCQs(msc);
      }
    }
  }

  elasticSearchMCQs(mcqs: string) {
    Vue.axios
      .post(
        "https://search.pgc.edu.pk/mcqs/wedgets/" +
          this.auth.session.userId +
          "!" +
          mcqs.split("=")[0],
        {
          body: { leftside: "mcqs", rightside: mcqs },
        }
      )
      .then((response) => {});
  }

  resetMCQ() {
    let spliced = 0;
    for (let i = this.savedOperations.length - 1; i >= 0; i--) {
      if (this.savedOperations[i].isPastPaper == this.isPastPaper) {
        this.savedOperations.splice(i, 1);
        spliced++;
      }
    }

    this.attempted = 0;

    for (let i = 0; i < this.answers.length; i++) {
      this.answers[i].answer = false;
      this.answers[i].answerId = "";
    }

    this.checkAnswers = false;
    this.isResult = false;
    this.timeElapsed = "";
    this.startTime = moment();
    this.totalSeriesData = [];
    this.incorrect = 0;
    this.correct = 0;

    this.questionComponentKey++;
  }

  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "index",
        // A column that needs custom formatting
        { key: "fullName", label: "Chapter Name" },
        { key: "progress", label: "Attempted" },
      ],
      filter: null,
    };
  }

  created() {
    this.level_id = localStorage[config.classLevl];
    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }
    window.scrollTo(0, 0);
    this.getQuestions();
    this.service.getTopicMarks(this.topicId).then((response) => {
      if (response) {
        this.lastSaved = response[0].result;
      }
    });
  }

  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.handler);
    // this.saveWatched();
  }

  // async handler(event) {
  //   event.preventDefault();
  //   try {
  //     // API call here
  //     await this.saveWatched();
  //     return ""; // Prompt with default browser message
  //   } catch (err) {
  //     return undefined; // Skip prompt
  //   }
  // }
}

interface ProvidedAnswers {
  questionId: string;
  answer: boolean;
  answerId: string;
}
